<template>
  <div class="kom-number-container">
    <span>{{ i18n.t('/Configuration/KomNumber') }}: {{ configurationKomNumber }}</span>
    <app-button
      v-if="!isEditing"
      data-qa="edit-kom-number-button"
      :disabled="quoteStatusIsSalesOrder"
      @click="toggleEditState()"
    >
      <icon class="icon" icon="pencil" />
    </app-button>
    <div v-else class="edit-form">
      <form-input
        id="kom-number"
        v-model.lazy="komNumber"
        :show-label="false"
        title="kom-numbmer"
        maxlength="50"
        type="text"
      />
      <app-button data-qa="save-kom-number-button" @click="submit">
        {{ i18n.t('/Common/Save') }}
      </app-button>
      <app-button data-qa="cancel-edit-kom-number-button" @click="toggleEditState()">
        <icon class="icon" icon="close" />
      </app-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    AppButton,
    FormInput,
    Icon,
  },
  props: {
    orderService: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      komNumber: '',
      isEditing: false,
    }
  },
  computed: {
    ...mapState({
      stateKomNumber(state) {
        return state[this.orderService.type]?.car?.KomNumber?.Number
      },
    }),
    ...mapGetters({
      configurationKomNumber: 'configuration/komNumber',
      quoteStatusIsSalesOrder: 'quote/quoteStatusIsSalesOrder',
    }),
  },
  methods: {
    toggleEditState() {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.komNumber = this.stateKomNumber
      }
    },
    submit() {
      EventBus.$emit('kom-number-changed', this.komNumber.trim())
      this.toggleEditState()
    },
  },
}
</script>

<style lang="scss" scoped>
.kom-number-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  span {
    margin-right: 0.25rem;
  }

  .edit-form {
    display: flex;
  }
}
</style>
